export default __webpack_public_path__ + "static/media/10N.57f4e501.jpg";